
$(document).ready(function () {


    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {

        quickView();

    });

});

document.addEventListener("cart:updated", function (e) {

    $.fancybox.close();

});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


function quickView() {

    $(".quick-view").on("click", function (event) {

        event.stopPropagation();

        // console.log("QUICKVIEW");

        if ($('#quick-view').length == 0) { $("body").append('<div id="quick-view"></div>'); }

        var product_handle = $(this).data('handle');

        $('#quick-view').addClass(product_handle);

        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

            var title = product.title;

            var type = product.type;

            var price = 0;

            var original_price = 0;

            var productId = product.id;

            var desc = product.description;

            var images = product.images;

            var feature_image = product.featured_image;

            //console.log("pRODUCT", product);

            var variants = product.variants;

            var options = product.options;

            var url = '/products/' + product_handle;

            $('.qv-product-title').text(title);

            $('.handle-breadcrumb').text(title);

            $('.qv-product-type').text(type);

            $('.qv-product-description').html(desc);

            $('.view-product').attr('href', url);

            var imageCount = $(images).length;



            var image_embed = '<div><img class="lazy2 feature-view-image" src="' + feature_image + '" data-src="' + feature_image + '"></div>';

            image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');

            if ($('.feature-view-image').length == 0) {

                $('.qv-product-images').append(image_embed);

            }

            $(options).each(function (i, option) {

                var opt = option.name;

                var selectClass = '.option.' + opt.toLowerCase();

                if ($('.option-selection-size').length == 0) {

                    $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');

                }

                $(option.values).each(function (i, value) {

                    var optionSold = document.getElementById(productId + value);




                    if (!optionSold) {
                        $('.option.' + opt.toLowerCase()).append('<option id="' + productId + value + '"  value="' + value + '">' + value + '</option>');
                    }






                });

            });

            $(product.variants).each(function (i, v) {

                if (v.inventory_quantity == 0) {

                    var optionSold = document.getElementById(productId + v.option2);

                    if (!optionSold.textContent.includes("Sold Out")) {

                        optionSold.append(' - Sold Out');
                    }

                    $('.qv-add-button').prop('disabled', true).val('Sold Out');

                    $('.qv-product-price').text('Sold Out').show();

                    return true

                } else {

                    $('.qv-add-button').attr('onclick', `Neptune.cart.addItem(${v.id},1,_n.parents(this,'[neptune-product]').properties); return false`);

                    $('.qv-add-button').prop('disabled', false).val('Add to Cart')


                    price = parseFloat(v.price / 100).toFixed(2);

                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

                    $('.qv-product-price').text('$' + price);

                    if (original_price > 0) {

                        $('.qv-product-original-price').text('$' + original_price).show();

                    } else {

                        $('.qv-product-original-price').hide();

                    }

                    $('select.option-1').val(v.option2);

                    return false

                }

            });

        });



        $(document).on("change", "#quick-view select", function () {

            var selectedOptions = '';

            $('#quick-view select').each(function (i) {

                if (selectedOptions == '') {

                    selectedOptions = $(this).val();

                } else {

                    selectedOptions = selectedOptions + ' / ' + $(this).val();

                }

            });

            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

                $(product.variants).each(function (i, v) {

                    if (v.title == selectedOptions) {

                        var v_qty = v.inventory_quantity;

                        var v_inv = v.inventory_management;

                        if (v_inv == null) {

                            $('.qv-add-button').prop('disabled', false).val('Add to Cart');

                        } else {

                            if (v.inventory_quantity < 1) {

                                //console.log("INSERT CHANGE");

                                $('.qv-add-button').prop('disabled', true).val('Sold Out');

                            } else {

                                //console.log("INSERT CHANGE");

                                $('.qv-add-button').attr('onclick', `Neptune.cart.addItem(${v.id},1,_n.parents(this,'[neptune-product]').properties); return false`);

                                $('.qv-add-button').prop('disabled', false).val('Add to Cart');

                            }

                        }

                    }

                });

            });

        });

        $.fancybox({

            href: '#quick-view',

            maxWidth: 1140,

            maxHeight: 600,

            fitToView: true,

            width: '90%',

            height: '100%',

            autoSize: false,

            closeClick: false,

            openEffect: 'none',

            closeEffect: 'none',

            padding: 0,

            helpers: {
                overlay: {
                    locked: false,
                },
            },

            'beforeLoad': function () {

                var product_handle = $('#quick-view').attr('class');

                $(document).on("click", ".qv-add-button", function () {

                    var qty = $('.qv-quantity').val();

                    var selectedOptions = '';

                    var var_id = '';

                    $('#quick-view select').each(function (i) {

                        if (selectedOptions == '') {

                            selectedOptions = $(this).val();

                        } else {

                            selectedOptions = selectedOptions + ' / ' + $(this).val();

                        }

                    });
                    /* 
                                        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                    
                                            $(product.variants).each(function (i, v) {
                    
                                                if (v.title == selectedOptions) {
                    
                                                    var_id = v.id;
                    
                    
                    
                                                }
                    
                                            });
                    
                                        }); */

                });

                $('.fancybox-wrap').css('overflow', 'hidden !important');

            },

            'afterShow': function () {

                $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {

                    $('.qv-product-images').addClass('loaded');

                });

                $('body').addClass('active-quick-view');

            },

            'afterClose': function () {

                $('body').removeClass('active-quick-view');
                $('#quick-view').removeClass().empty();

            },

            'onClosed': function () {



            }

        });

    });

};



